export enum TodoType {
  GROWELAB = 'growelab',
  ESUITE = 'esuite',
  EGROWE = 'egrowe',
  PLAN_DELIVERABLE = 'implementation_deliverable',
  PLAN_ACTION_ITEM = 'implementation_action_item',
}
